export default __webpack_public_path__ + "static/media/RockinTuna-ArtistBG-m-2x.ea143647.jpg";